export const TM_COMPANY_USER_TAG_NAME = 'tm-company-user';
